import React, { useEffect, useState, useRef, useContext } from "react";
import { Container, Row, Col, Form, Button, InputGroup } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faInstagram } from "@fortawesome/free-brands-svg-icons";

// Core context providers and shared view sub-elements
import { Context } from "../../../../../utils/context";
import Animation from "../animation/Animation";
import ContactModal from "../ContactModal/ContactModal";
import SignUpModal from "../SignUpModal/ContactModal";

const Getotp = () => {
  // Application global context access pipelines
  const { postData, PostGoogleLogin, setSignin, setUsertype } =
    useContext(Context);
  const navigate = useNavigate();

  // Controlled verification element states
  const [phone, setPhone] = useState("");
  const [mobileErr, setMobileErr] = useState("");
  const [otpERR, setOtpErr] = useState("");
  const [otpsend, setOtpSend] = useState(null);
  const [authToken, setAuthToken] = useState(null);
  const [authType, setAuthType] = useState(null);

  // Layout presentation toggles
  const [modalShow, setModalShow] = useState(false);
  const [signModalShow, setSignModalShow] = useState(false);
  const [timerShow, setTimerShow] = useState(false);
  const [seconds, setSeconds] = useState(60);
  const [isTimerExpired, setIsTimerExpired] = useState(true);

  // Security Verification Input References Grid Matrix
  const [otpValues, setOtpValues] = useState(["", "", "", ""]);
  const inputRefs = [useRef(), useRef(), useRef(), useRef()];

  // Realtime clock decay evaluation frame loop
  useEffect(() => {
    const decrementTimer = () => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      } else {
        setIsTimerExpired(true);
        setOtpSend(null);
      }
    };
    const timerInterval = setInterval(decrementTimer, 1000);
    return () => clearInterval(timerInterval);
  }, [seconds]);

  // Clean numerical string mutation rules
  const handleMobileChange = (event) => {
    const newValue = event.target.value.replace(/[^0-9]/g, "");
    setPhone(newValue);
    setMobileErr("");
  };

  // Asynchronous mobile format validation routine
  const handleValidation = async () => {
    const mobile = phone;
    const errors = [];

    if (mobile?.trim() === "") {
      setMobileErr("Mobile Number is required");
      errors.push("Mobile Number is required");
    } else if (!/^\d{10}$/.test(mobile)) {
      setMobileErr("Mobile Number should be a 10-digit number");
      errors.push("Mobile Number should be a 10-digit number");
    }

    if (errors.length === 0) {
      setMobileErr("");
      const randOtp = Math.floor(1000 + Math.random() * 9000).toString();

      const res = await postData("/without-login/recruiters/sign-in", {
        contact_no: "91" + mobile,
        otp: randOtp,
      });

      if (res?.success) {
        setAuthToken(res.data.token);
        setAuthType(res.data.type);
        setOtpSend(randOtp);
        setModalShow(true);
        setTimerShow(true);
        setIsTimerExpired(false);
        setOtpErr("");
        setOtpValues(["", "", "", ""]);
        setSeconds(60);
        setTimeout(() => {
          setModalShow(false);
        }, 4000);
      } else {
        setMobileErr(res?.message);
      }
    }
  };

  // Matrix text shifting focusing control configuration mapping
  const handleOtpChange = (index, event) => {
    setOtpErr("");
    const inputValue = event.target.value;

    if (/^[0-9]*$/.test(inputValue) || inputValue === "") {
      const workingOtpValues = [...otpValues];
      workingOtpValues[index] = inputValue;
      setOtpValues(workingOtpValues);

      const computedOtp = workingOtpValues.join("");

      if (otpsend === computedOtp) {
        setOtpErr("");
        setOtpValues(["", "", "", ""]);
        Cookies.set("echohouse_website", authToken, { expires: 1 });
        Cookies.set("jwtType", authType, { expires: 1 });
        setSignModalShow(true);
        setModalShow(true);
        setSignin(true);
        setUsertype(authType);

        setTimeout(() => {
          setSignModalShow(false);
          setOtpSend(null);
          navigate("/dashboardmain");
        }, 4000);
      } else if (inputValue !== "" && index < 3) {
        inputRefs[index + 1].current.focus();
      } else if (computedOtp.length === 4 && otpsend !== computedOtp) {
        setOtpErr("OTP Invalid!");
      }
    }
  };

  // Backward element target field array clearing logic
  const handleKeyDown = (index, event) => {
    setOtpErr("");
    if (event.key === "Backspace" && index > 0 && otpValues[index] === "") {
      const targetOtpValues = [...otpValues];
      targetOtpValues[index - 1] = "";
      setOtpValues(targetOtpValues);
      inputRefs[index - 1].current.focus();
    }
  };

  // Google Single Sign-On federation route callback mapping
  const handleSuccess = async (data) => {
    const values = {
      token: data.credential,
      type: "Recruiter",
    };
    const res = await PostGoogleLogin("/without-login/google-login", values);
    if (res?.success) {
      Cookies.set("echohouse_website", res.data.token, { expires: 1 });
      Cookies.set("jwtType", res.data.type, { expires: 1 });
      setSignModalShow(true);
      setTimeout(() => {
        setSignModalShow(false);
        window.location.href = "/dashboardmain";
      }, 4000);
    } else {
      setMobileErr(res?.message);
    }
  };

  return (
    <>
      <Container fluid className="split-login-container p-0">
        <Row className="g-0 split_login_container_holder">
          {/* LEFT PANEL - Graphics Showcase & Sub-Footer */}
          <Col
            lg={6}
            className="split-left-panel d-none d-lg-flex flex-column justify-content-between"
          >
            <div className="showcase-content-wrapper m-auto position-relative">
             
              <div className="animation-overlay-box">
                <Animation />
              </div>
            </div>

           
          </Col>

          {/* RIGHT PANEL - Authentication Layout Control Column */}
          <Col
            lg={6}
            xs={12}
            className="split-right-panel d-flex flex-column justify-content-between"
          >
            <div className="login-form-core m-auto w-100 ">
              {/* Layout Presentation Header Titles */}

              <div className="login-header-group mb-4">
                <h2>Welcome Back!</h2>
                <p className="login-subtitle text-muted">
                  Logging in as{" "}
                  <strong className="text-capitalize">Recruiter</strong>
                </p>
              </div>

              {/* Data Field Handling Control Blocks */}
              <Form.Group className="mb-3">
                <Form.Label className="field-top-label fw-semibold small text-muted">
                  Mobile Number <span className="text-danger">*</span>
                </Form.Label>
                <InputGroup className="phone-input-combo">
                  <InputGroup.Text className="phone-prefix-addon bg-light border-end-0">
                    +91
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    minLength="10"
                    maxLength="10"
                    disabled={timerShow && !isTimerExpired}
                    placeholder="Enter your 10-digit Mobile Number"
                    value={phone}
                    className="foundit-input-style border-start-0 shadow-none"
                    onKeyDown={(event) => {
                      if (
                        !/[0-9]/.test(event.key) &&
                        event.key !== "Backspace"
                      ) {
                        event.preventDefault();
                      }
                    }}
                    onChange={handleMobileChange}
                  />
                </InputGroup>
                {mobileErr && (
                  <div className="error-hint-text text-danger mt-1 small">
                    {mobileErr}
                  </div>
                )}
              </Form.Group>

              {/* State Dependent Processing Form Buttons */}
              <div className="submit-action-area mb-4">
                {!timerShow ? (
                  <Button
                    className="foundit-primary-btn active-state w-100 py-2 fw-semibold"
                    onClick={handleValidation}
                    style={{
                      backgroundColor: "#7B00D3",
                      borderColor: "#7B00D3",
                    }}
                  >
                    Send OTP
                  </Button>
                ) : isTimerExpired ? (
                  <Button
                    className="foundit-primary-btn active-state w-100 py-2 fw-semibold"
                    onClick={handleValidation}
                    style={{
                      backgroundColor: "#7B00D3",
                      borderColor: "#7B00D3",
                    }}
                  >
                    Resend OTP
                  </Button>
                ) : (
                  <Button
                    className="foundit-primary-btn w-100 py-2 fw-semibold"
                    disabled
                  >
                    OTP Sent
                  </Button>
                )}
              </div>

              {/* Security OTP Context Verification Blocks */}
              {timerShow && !isTimerExpired && (
                <div className="otp-embedded-box text-center mb-4 p-3 bg-light rounded">
                  <p className="otp-alert-msg small text-muted mb-2">
                    Enter OTP within{" "}
                    <strong>{`${Math.floor(seconds / 60)}:${(seconds % 60).toString().padStart(2, "0")}`}</strong>{" "}
                    seconds
                  </p>
                  <div className="d-flex justify-content-center gap-2 my-2">
                    {otpValues.map((value, index) => (
                      <Form.Control
                        key={index}
                        className="otp-clean-input text-center shadow-none"
                        type="text"
                        maxLength="1"
                        value={value}
                        onChange={(e) => handleOtpChange(index, e)}
                        onKeyDown={(e) => handleKeyDown(index, e)}
                        ref={inputRefs[index]}
                        style={{ width: "45px", height: "45px" }}
                      />
                    ))}
                  </div>
                  {otpERR && (
                    <div className="error-hint-text text-danger small mt-1">
                      {otpERR}
                    </div>
                  )}
                </div>
              )}

              <div className="text-divider mb-4 position-relative text-center">
                <span className="bg-white px-3 text-muted small">
                  or continue with
                </span>
              </div>

              {/* Identity Providers SSO Integration Node */}
              <div className="oauth-row d-flex gap-3 mb-4">
                <div className="flex-grow-1 google-btn-wrapper ">
                  <GoogleOAuthProvider clientId="189802957201-b49b89i8t1t0cbcfuedll714lo1d2r0r.apps.googleusercontent.com">
                    <GoogleLogin
                      className="mx-auto"
                      onSuccess={handleSuccess}
                      onError={() => {}}
                    />
                  </GoogleOAuthProvider>
                </div>
              </div>

              <div className="user-holder text-center mt-4 mb-2">
                <p className="text-muted small">
                  New To Placement Platform ?
                  <Link
                    to="/signup-recruiter"
                    className="ms-2 fw-bold text-decoration-none"
                    style={{ color: "#163977" }}
                  >
                    Create Account
                  </Link>
                </p>
              </div>
            </div>

            {/* Meta Segment Information Column Footer */}
            <div className="right-panel-footer border-top pt-4 mt-5">
              <Row className="text-start justify-content-between g-3">
               
                <Col md={12} xs={12} className="footer-sub-block text-center">
                  <h5 className="fw-bold mb-2">Employers Portal</h5>
                  <Button
                    size="sm"
                    variant="light"
                    className="employer-mini-btn border rounded-pill px-3"
                    onClick={() => navigate("/getotp-jobseeker")}
                  >
                    Switch to Job Seeker
                  </Button>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Verification Layer Status Modals */}
      <ContactModal show={modalShow} onHide={() => setModalShow(false)} />
      <SignUpModal
        show={signModalShow}
        onHide={() => setSignModalShow(false)}
      />
    </>
  );
};

export default Getotp;
